"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIENT_REPORTED_EVENTS = exports.AnalyticsEventEnum = void 0;
var AnalyticsEventEnum;
(function (AnalyticsEventEnum) {
    AnalyticsEventEnum["BEHAVIOR_TRACKED"] = "behavior_tracked";
    AnalyticsEventEnum["INCIDENT_LOGGED"] = "incident_logged";
    AnalyticsEventEnum["PASS_PRINTED"] = "pass_printed";
    AnalyticsEventEnum["STUDENT_COMPLIED"] = "student_complied";
    AnalyticsEventEnum["DAILY_ACTIVITY_REPORT_RUN"] = "daily_activity_report_run";
    AnalyticsEventEnum["EVENT_CREATED"] = "event_created";
    AnalyticsEventEnum["IMPORT_FAILED"] = "import_failed";
    AnalyticsEventEnum["GUARDIAN_LOGGED_IN"] = "guardian_logged_in";
})(AnalyticsEventEnum || (exports.AnalyticsEventEnum = AnalyticsEventEnum = {}));
/**
 * Events the web can report through the analytics endpoint. Printing a pass in
 * the browser never reaches the API, so the client has to report it.
 */
exports.CLIENT_REPORTED_EVENTS = [AnalyticsEventEnum.PASS_PRINTED];
